<template>
  <form @submit.prevent="save">
    <div class="mb-3">
      <label class="d-block" for="">Tipo</label>
      <div class="custom-control custom-radio custom-control-inline">
        <input
          v-model="type_id"
          value="3"
          type="radio"
          :id="_uid + 'cr'"
          :name="'customRadio' + _uid"
          class="custom-control-input"
        />
        <label class="custom-control-label" :for="_uid + 'cr'">Producto</label>
      </div>
      <div class="custom-control custom-radio custom-control-inline">
        <input
          v-model="type_id"
          value="1"
          type="radio"
          :id="_uid + 'cr3'"
          :name="'customRadio' + _uid"
          class="custom-control-input"
        />
        <label class="custom-control-label" :for="_uid + 'cr3'">Servicio</label>
      </div>
      <div class="custom-control custom-radio custom-control-inline">
        <input
          v-model="type_id"
          value="2"
          type="radio"
          :id="_uid + 'cr2'"
          :name="'customRadio' + _uid"
          class="custom-control-input"
        />
        <label class="custom-control-label" :for="_uid + 'cr2'">Sub menu</label>
      </div>
    </div>
    <div class="mb-3">
      <label for="">Etiqueta</label>
      <input type="text" class="form-control" maxlength="255" v-model="name" />
    </div>
    <div class="mb-3">
      <label for="">Precio</label>
      <input type="number" class="form-control" 
        v-model.number="product.unit_price" step="0.01"/>
    </div>
    <div class="mb-3">
      <label for="">Categoria de FI</label>
      <SelectSource
        ref="elSelectSource"
        v-model="product.source_id"
      ></SelectSource>
    </div>
    <div class="mb-3 d-flex">
      <div class="w-50">
        <label for="">Estado inicial</label>
        <SelectState :showLabels="true" v-model="status"></SelectState>
      </div>
      <div class="w-50">
        <label for="">Estado siguiente</label>
        <SelectState :showLabels="true" v-model="status_target"></SelectState>
      </div>
    </div>
    <!-- <div class="mb-3"> -->
    <!--   <label for="">Color</label> -->
    <!--   <SelectFlagColor v-model="flag"></SelectFlagColor> -->
    <!-- </div> -->
    <div class="mb-3">
      <label for="">Pieza Objetivo:</label>
      <select v-model="piece" class="custom-select">
        <option :value="null">Ninguno</option>
        <option value="101">Arc Sup</option>
        <option value="102">Arc Inf</option>
        <option value="2">Multiseleccion</option>
        <option value="0">Todos</option>
      </select>
    </div>
    <div class="mb-3">
      <label for="">Orden</label>
      <input type="text" v-model="order" class="form-control" />
    </div>
    <button class="btn btn-primary" type="submit">Guardar</button>
  </form>
</template>
<script>
import StoreService from "src/lt/store-module/StoreService.js";
import SelectState from "./SelectState.vue";
import { DentalClinicService } from "src/dental-clinic-module/service";
import SelectSource from "src/lt/admin-module/sources/Select.vue";

export default {
  components: {
    SelectState,
    SelectSource,
  },

  // directives
  // filters

  props: {
    menu_id: {},
    group: {}
  },

  data: () => ({
    id: null,
    // group: null,
    name: null,
    type_id: null,
    class_icon: null,
    status: null,
    status_target: null,
    flag: null,
    product_id: null,
    piece: null,
    order: null,
    product: {
      unit_price: null,
      name: null,
      source_id: null,
    },
    product_ready: false,
    // menu_id: null
  }),

  computed: {
    //
  },

  watch: {
    //
  },

  mounted() {
    //
  },

  methods: {
    reset() {
      this.id = null;
      this.name = null;
      this.type_id = 1;
      this.class_icon = null;
      this.status = null;
      this.status_target = null;
      this.flag = null;
      this.product_id = null;
      this.piece = null;
      this.order = null;
      this.product = {};
      this.product_ready = false;
      this.$refs.elSelectSource.reset();
    },
    async setValue(value) {
      this.id = value.id;
      this.name = value.name;
      this.type_id = value.type_id;
      this.class_icon = value.class_icon;
      this.status = value.status;
      this.status_target = value.status_target;
      this.flag = value.flag;
      this.product_id = value.product_id;
      this.piece = value.piece;
      this.order = value.order;
      if(this.product_id) {
        let prod = await StoreService.getProduct(value.product_id);
        this.product = prod;
        this.product_ready=true;
        if(prod.source_id) {
          this.$refs.elSelectSource.setValue(prod.source_id);
        } else {
          this.$refs.elSelectSource.reset();
        }
      }
    },
    async save() {
      try {
        if(this.type_id == 3) {
          this.product.type_id = 1;
        }
        else if (this.type_id == 1) {
          this.product.type_id = 2;
        }
        if(this.type_id != 2) {
          this.product.name = this.name;
          delete this.product.categorie_name;
          if(!this.product_id && !this.id) {
            // registro nuevo
            let prodRes = await StoreService.saveProduct({
              ...this.product,
              code: "ODONTO-" + Math.random().toString(36).substring(2, 15).toUpperCase(),
            });
            this.product_id = prodRes.id;
          } else {
            // actualizacion de precio, fuente ingreso
            await StoreService.saveProduct(this.product);
          }
        }
        var result = await DentalClinicService.saveOdontogramMenu({
          ...this.$data,
          menu_id: this.menu_id,
          group: this.group
        });
        this.$emit("submitted", result);
      } catch (e) {
        window.alert("Algo salio mal");
      }
    }
  }
};
</script>

<style></style>
